import { signalStore } from '@ngrx/signals';
import { withCartItem } from './features/withCartItem';
import { withCartItemPricing } from './features/withCartItemPricing';

export const CartItemComponentStore = signalStore(withCartItem(), withCartItemPricing());
export type CartItemComponentStore = InstanceType<typeof CartItemComponentStore>;
